import { collection, doc } from 'firebase/firestore';

export const WORKSPACE_COLLECTION = 'workspaces';

export const getWorkspaceDocPath = (userId, workspaceId) => {
    return `users/${userId}/${WORKSPACE_COLLECTION}/${workspaceId}`;
};

export const getWorkspaceCollectionRef = (firestore, userId) => {
    return collection(firestore, `users/${userId}/${WORKSPACE_COLLECTION}`);
};

export const getWorkspaceDocRef = (firestore, userId, workspaceId) => {
    return doc(firestore, getWorkspaceDocPath(userId, workspaceId));
};

export const getWorkspaceSubcollectionRef = (firestore, userId, workspaceId, subcollectionName) => {
    return collection(firestore, `${getWorkspaceDocPath(userId, workspaceId)}/${subcollectionName}`);
};

export const getWorkspaceSubdocRef = (firestore, userId, workspaceId, subcollectionName, docId) => {
    return doc(firestore, `${getWorkspaceDocPath(userId, workspaceId)}/${subcollectionName}/${docId}`);
};